import type { TaskViewModel } from '@trinnvis/dabih-api-client';
import type { OrganizationState } from '../../types';

export function toTaskViewModel(item: TaskViewModel, o: OrganizationState): TaskViewModel & { functionName: string } {
  const functionName = item.functionUuid ? o.functionsById[item.functionUuid].name : '';
  return Object.assign({}, item, {
    functionName: functionName === undefined ? '' : functionName,
  });
}
